import type * as lazyIndex from "./lazyIndex";
import { LazyImport, LazyModule, registerLazyOrchestrator } from "owa-bundling";
import openInClientStoreAction from "owa-addins-view/lib/actions/openInClientStore";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "AddinsMarketplace" */ "./lazyIndex"), { name: "AddinsMarketplace" });

export const lazyStoreLinkHandler: LazyImport<typeof lazyIndex.storeLinkHandler, typeof lazyModule> = new LazyImport(lazyModule, m => m.storeLinkHandler);
export const lazyLaunchStoreUrl: LazyImport<typeof lazyIndex.launchStoreUrl, typeof lazyModule> = new LazyImport(lazyModule, m => m.launchStoreUrl);

registerLazyOrchestrator(openInClientStoreAction, lazyModule, m => m.openInClientStoreOrchestrator);
